import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { portalUri } from '../../utils';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../Store';

function Footer(props) {
    const rawLayoutUri = props?.config?.config?.lottery_host;
    let lottery_host;
    if (rawLayoutUri) {
        const layoutUrl = new URL(rawLayoutUri);
        const layoutDomainName = layoutUrl?.hostname;
        lottery_host = `https://${layoutDomainName}/`;
    } else {
        lottery_host = `https://palottery.pa.gov/`;
    }
    return (
        <footer id='footer' className='page-footer'>
            <section className='footer-section first-footer-section'>
                <div className='helpline'>
                    <div className='helpline-term'>PROBLEM GAMBLING HELPLINE:</div>
                    <a className='helpline-link' href='tel:18004262537'>
                        1-800-GAMBLER (1-800-426-2537)
                    </a>
                </div>

                <div className='payment_modes'>
                    <h2>Play Online</h2>
                    <div className='payment_party'>
                        <a className='payment_party__link' href={portalUri + 'p/funding-methods/'}>
                            <img className='payment_party__icon' src='/assets/images/ach.png' alt='Pay with ACH e-check' />
                        </a>
                        <a className='payment_party__link' href={portalUri + 'p/funding-methods/'}>
                            <img className='payment_party__icon' src='/assets/images/visa.svg' alt='Pay with Visa' />
                        </a>
                        <a className='payment_party__link' href={portalUri + 'p/funding-methods/'}>
                            <img className='payment_party__icon' src='/assets/images/mc.png' alt='Pay with MasterCard' />
                        </a>
                        <a className='payment_party__link' href={portalUri + 'p/funding-methods/'}>
                            <img className='payment_party__icon' src='/assets/images/discover.png' alt='Pay with Discover' />
                        </a>
                        <a className='payment_party__link' href={portalUri + 'p/funding-methods/'}>
                            <img className='payment_party__icon' src='/assets/images/paypal.png' alt='Pay with PayPal' />
                        </a>
                        <a className='payment_party__link' href={portalUri + 'p/funding-methods/'}>
                            <img className='payment_party__icon' src='/assets/images/playplus.png' alt='Pay with Play Plus' />
                        </a>
                        <a className='payment_party__link' href={portalUri + 'p/funding-methods/'}>
                            <img className='payment_party__icon' src='/assets/images/webcash.png' alt='Pay with iLottery WebCash' />
                        </a>
                    </div>
                </div>

                <p className='flex row around footer-nav' id='bottom-nav'></p>
                <div className='flex row center footer-nav'>
                    <span>
                        <strong>Call:</strong> <a href='tel:18335307529'>1-833-530-PLAY (7529)</a>{' '}
                    </span>
                    &nbsp; &nbsp;&nbsp;
                    <span>
                        <strong> Email:</strong> <a href='mailto:support@pailottery.com'>support@PaiLottery.com</a>{' '}
                    </span>
                </div>
            </section>
            <section className='footer-section-alt flex row'>
                <div className='app_left'>
                    <h2>Get The PA Lottery Official App</h2>
                    <a href={'https://apps.apple.com/us/app/pa-lottery-official-app/id910842501'} className='app_store' rel='noreferrer' target='_blank'>
                        <img alt='Download on the App Store' role='presentation' src='/assets/images/Apple_App_Store.png' />
                    </a>
                    <a href={'https://play.google.com/store/apps/details?id=com.sgi.palottery'} className='google_play' rel='noreferrer' target='_blank'>
                        <img alt='Get It On Google Play' role='presentation' src='/assets/images/Get_it_on_Google_play.png' />
                    </a>
                </div>

                <div className='app_right'>
                    <h2>Connect</h2>

                    <p className='social-icons flex row'>
                        <a href={'https://www.facebook.com/palottery/'} rel='noreferrer' target='_blank'>
                            <i className='fab fa-facebook'>
                                <span className='accessible-text'>Facebook</span>
                            </i>
                        </a>
                        <a href={'https://www.instagram.com/palottery/'} rel='noreferrer' target='_blank'>
                            <i className='fab fa-instagram'>
                                <span className='accessible-text'>Instagram</span>
                            </i>
                        </a>
                        <a href={'https://vimeo.com/pennsylvanialottery'} rel='noreferrer' target='_blank'>
                            <i className='fab fa-vimeo'>
                                <span className='accessible-text'>Vimeo</span>
                            </i>
                        </a>
                        <a href={'https://www.youtube.com/user/PennsylvaniaLottery'} rel='noreferrer' target='_blank'>
                            <i className='fab fa-youtube'>
                                <span className='accessible-text'>YouTube</span>
                            </i>
                        </a>
                        <a href={lottery_host + 'About-PA-Lottery/Subscribe-to-RSS.aspx'}>
                            <i className='fas fa-rss' style={{ marginRight: '0px' }}>
                                <span className='accessible-text'>RSS</span>
                            </i>
                        </a>
                    </p>
                </div>
            </section>

            <section className='footer-section'>
                <h2>Additional Resources</h2>

                <p className='flex row around'>
                    <a href={'https://www.pa.gov/privacy-policy/'}>Privacy Statement</a>{' '}
                    <a href={lottery_host + 'About-PA-Lottery/Player-Security.aspx'}>Player Security</a>
                    <a href={lottery_host + 'About-PA-Lottery/Footer/Sitemap.aspx'}>Sitemap</a>
                    <a href={lottery_host + 'About-PA-Lottery/Footer/Americans-with-Disabilities-Act.aspx'}>
                        <i className='fas fa-wheelchair'>&nbsp;</i>
                        &nbsp;Americans with Disabilities Act
                    </a>
                </p>

                <p className='flex row around'>
                    <a href={lottery_host + 'About-PA-Lottery/Please-Play-Responsibly.aspx'}>Please Play Responsibly</a>
                    <a href={'https://www.pa.gov/'} rel='noreferrer' target='_blank'>
                        PA.gov
                    </a>{' '}
                    <a href={lottery_host + 'About-PA-Lottery/Footer/Amber-Alert.aspx'}>Amber Alert</a>{' '}
                    <a href={'https://www.governor.pa.gov/'} rel='noreferrer' target='_blank'>
                        Josh Shapiro, Governor
                    </a>
                </p>

                <p>
                    <strong>The Pennsylvania Lottery</strong>
                    <br />
                    1200 Fulling Mill Road, Suite One, Middletown, PA 17057
                    <br />
                    Call: 1-800-692-7481 | <a href={lottery_host + 'About-PA-Lottery/Contact-Us.aspx'}>More Contact Options</a>
                </p>

                <p style={{ fontSize: '12px' }}>
                    <strong>&copy;&nbsp;{new Date().getFullYear()}&nbsp;PA Lottery</strong>
                </p>

                <p style={{ fontSize: '12px' }}>
                    Players Must Be 18 Years or Older.
                    <br />
                    Players must be located within Pennsylvania for online play.
                    <br />
                    Please Play Responsibly.
                </p>

                <div className='flex row footer-logos'>
                    <span>
                        <a className='footer-logo-link' href='https://www.pacouncil.com/' target='_blank' rel='noopener noreferrer'>
                            <img className='footer-logo-link-image' src='/assets/images/ccgp-logo.png' alt='ccgp logo' />
                        </a>
                    </span>
                    <span>
                        <a className='footer-logo-link' href='https://www.ncpgambling.org/ncpg/' target='_blank' rel='noopener noreferrer'>
                            <img
                                className='footer-logo-link-image'
                                src='/assets/images/NCPG-2026-SilverMember.png'
                                alt='NCPG Silver Member 2026 – Go to homepage'
                            />
                        </a>
                    </span>
                    <span>
                        <a
                            className='footer-logo-link'
                            href='https://www.ncpgambling.org/programs-resources/responsible-gambling/icap/'
                            target='_blank'
                            rel='noopener noreferrer'>
                            <img className='footer-logo-link-image' src='/assets/images/icap-logo.png' alt='icap logo' />
                        </a>
                    </span>
                    <span>
                        <a
                            className='footer-logo-link'
                            href={`${rawLayoutUri}About-PA-Lottery/Please-Play-Responsibly.aspx`}
                            target='_blank'
                            rel='noopener noreferrer'>
                            <img className='footer-logo-link-image' src='/assets/images/wla-logo-white.png' alt='wla logo' />
                        </a>
                    </span>
                </div>

                <p style={{ fontSize: '12px' }}>
                    Every effort is made to ensure the accuracy of the winning numbers, prize payouts and other information posted on the Pennsylvania
                    Lottery&#39;s website. The official winning numbers are those selected in the respective drawings and recorded under the observation of an
                    independent accounting firm. In the event of a discrepancy, the official drawing results shall prevail.
                </p>
            </section>
        </footer>
    );
}

Footer.propTypes = {
    props: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
